// Frameweb uses hash routing, so the query string can live in the hash (`#/route?lang=es&apiKey=x`)
// and URLSearchParams on `location.search` would miss it. Match on the full href instead.
// Stops at `&` and `#`, unlike splitting on "?lang=".
export function getLangFromUrl(href) {
  const match = /[?&]lang=([^&#]*)/.exec(href);
  return match ? match[1] : "";
}
